import { format } from 'date-fns';
import { getRequest } from '../requests';

function getCurrentOffset() {
    return encodeURIComponent(format(new Date(), 'xxxxx'));
}

export function loadTasks(participantID?: string) {
    let url = `api/researchkit/categorizedtasks?offset=${getCurrentOffset()}`;
    if (participantID) {
        url = `${url}&participantID=${encodeURIComponent(participantID)}`;
    }
    return getRequest(url);
}
